import { __assign } from "tslib";
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actionCreators from '../../../actionCreators/handoff';
import ColumnSettings from '../../../components/handoff/layout/ColumnSettings';
import onlyIf from '../../../hocs/onlyIf';
import { getColumnSettings, getColumnsEnabled, getIsColumnOverlayOn, } from '../../../selectors/layoutOverlay';
function mapStateToProps(state) {
    try {
        // TODO remove when using easel api v2
        return __assign(__assign({}, getColumnSettings(state)), { isOverlayOn: getIsColumnOverlayOn(state), isOverlayEnabled: getColumnsEnabled(state) });
    }
    catch (e) {
        return {
            isOverlayEnabled: false,
        };
    }
}
function mapDispatchToProps(dispatch) {
    return {
        toggleOverlay: function () {
            dispatch(actionCreators.toggleColumnOverlay());
        },
    };
}
var isOverlayEnabled = function (props) { return props.isOverlayEnabled; };
export default compose(connect(mapStateToProps, mapDispatchToProps), onlyIf(isOverlayEnabled))(ColumnSettings);
